<template>
    <div style="line-height: 32px;">
        Reports for:
        <select name="company-select" class="select input" @change="setReportCompany" style="width: auto">
            <option value="none">All Companies</option>
            <option value="CF" :selected="reportCompany === 'CF'">Crockett Farms Only</option>
            <option value="BELLS" :selected="reportCompany === 'BELLS'">Bell's Farm Only</option>
        </select>
        between
        <input type="date" name="report-start" class="input" @input="setReportStart" :value="reportStartDate" style="width: auto;">
        and
        <input type="date" name="report-start" class="input" @input="setReportEnd" :value="reportEndDate" style="width: auto;">
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    export default {
        name: 'report-settings',
        data() {
            return {
                set_start_timeout: 0,
                set_end_timeout: 0,
            }
        },
        computed: mapGetters(['reportCompany', 'reportStartDate', 'reportEndDate']),
        methods: {
            setReportCompany(event) {
                let company = event.target.value === 'none' ? null : event.target.value
                this.$store.dispatch('SET_REPORT_COMPANY', company)
            },
            setReportStart(event) {
                clearTimeout(this.set_start_timeout);
                this.set_start_timeout = setTimeout(() => {
                    this.$store.dispatch('SET_REPORT_START', event.target.value)
                }, 1000)
            },
            setReportEnd(event) {
                clearTimeout(this.set_end_timeout);
                this.set_end_timeout = setTimeout(() => {
                    this.$store.dispatch('SET_REPORT_END', event.target.value)
                }, 1000)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ReportSettings.vue?7ca4c01a